/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPmiLineWeld = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M3.503 17.09V6.91h1.75v8.61h4.732v1.568H3.503zm8.957 0-2.127-7.365h1.722l1.274 4.83 1.4-4.62h1.386l1.4 4.704 1.316-4.914h1.666l-2.114 7.364H17.01l-1.596-5.194-1.582 5.194H12.46z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPmiLineWeld as PmiLineWeld };
